import { HeroForm } from "@/components/home/HeroForm";
import { Phone, ArrowRight } from "lucide-react";
import { Link } from "@/lib/router-compat";
import { Button } from "@/components/ui/button";
import bearMascot from "@/assets/kodiak-bear-mascot.png";
import heroVideo from "@/assets/hero-bg.webm";

export const Hero = () => {
  return (
    <section className="relative min-h-[85vh] flex items-center pt-24 lg:pt-20 overflow-hidden" aria-labelledby="hero-heading">
      {/* Background — video */}
      <div className="absolute inset-0 z-0">
        <video
          src={heroVideo}
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40" />
      </div>

      {/* Orange accent stripe */}
      <div className="absolute top-0 left-0 w-2 h-full bg-secondary z-10" />

      <div className="container mx-auto px-4 py-8 lg:py-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left: Copy */}
          <div className="animate-fade-up">
            <img
              src={bearMascot}
              alt="Kodiak Structures & Exteriors bear mascot"
              className="w-48 sm:w-56 lg:w-64 h-auto mb-6 drop-shadow-[0_10px_30px_rgba(0,0,0,0.6)]"
            />
            <div className="inline-block mb-4">
              <span className="text-sm font-semibold text-white bg-secondary/90 px-4 py-1.5 rounded-full font-subheading">
                Roofing · Siding · Exteriors
              </span>
            </div>
            <h1 id="hero-heading" className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]">
              BUILT TO LAST.{" "}
              <span className="text-secondary">BUILT BY KODIAK.</span>
            </h1>
            <p className="text-lg sm:text-xl text-white/90 font-medium mb-6 leading-relaxed drop-shadow-[0_1px_3px_rgba(0,0,0,0.5)]">
              Kodiak Structures & Exteriors delivers expert roofing, siding, window and gutter services built to withstand the toughest conditions. Serving homeowners throughout Minnesota.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/contact">
                <Button size="lg" className="bg-secondary hover:bg-secondary/90 text-secondary-foreground font-semibold font-subheading px-8">
                  Get a Free Estimate <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </Link>
              <a href="tel:6519831609">
                <Button size="lg" variant="outline" className="border-white/50 text-white hover:bg-white/10 font-semibold font-subheading px-8 bg-transparent">
                  <Phone className="w-5 h-5 mr-2" /> (651) 983-1609
                </Button>
              </a>
            </div>
          </div>

          {/* Right: Form */}
          <div className="animate-fade-up" style={{ animationDelay: '0.15s' }}>
            <HeroForm />
          </div>
        </div>
      </div>
    </section>
  );
};
